import React from 'react';

import AnimateReveal from '../AnimateReveal/AnimateReveal';
import LocationCard from '../LocationCard/LocationCard';
import Button from '../UI/Button/Button';
import Content from '../UI/Content/Content';
import Section from '../UI/Section/Section';
import Type from '../UI/Type/Type';
import { motion } from '../UI/framer-motion-custom';
import * as styles from './ConsultantDetails.module.scss';

const ConsultantDetails = ({ body, ratingLink, gmcNumber, location }) => {
  return (
    <Section>
      <AnimateReveal className={styles.container} staggerChildren={true}>
        <motion.div className={styles.body}>
          <Content items={body} />
        </motion.div>

        <motion.div className={styles.aside}>
          <div className={styles.sticky}>
            {ratingLink && (
              <div className={styles.row}>
                <Button to={ratingLink} isBlock>
                  View rating
                </Button>
              </div>
            )}

            {gmcNumber &&
              <div className={styles.row}>
                <Type.MetaHeading icon="briefcase">GMC Number</Type.MetaHeading>
                <p>{gmcNumber}</p>
              </div>
            }

            {location && (
              <div className={styles.row}>
                <Type.MetaHeading icon="map-pin">Location(s)</Type.MetaHeading>

                <ul className={styles.list}>
                  {location.map(
                    ({
                      id,
                      title,
                      uri,
                      locationDetails: { address, telephone, gallery },
                    }) => {
                      return (
                        <li key={id}>
                          <LocationCard
                            title={title}
                            path={uri}
                            address={address}
                            telephone={telephone}
                            image={gallery[ 0 ]}
                          />
                        </li>
                      );
                    }
                  )}
                </ul>
              </div>
            )}
          </div>
        </motion.div>
      </AnimateReveal>
    </Section>
  );
};

export default ConsultantDetails;
